/**
 * Auto Welcome Discount Script
 * Handles URL discount codes and falls back to GETSTARTED discount
 * The existing cart system will handle applying it automatically
 * 
 * possible parameters:
 * - open_discount=true
 * - continue=true
 * - scroll=element-id
 * - take-the-quiz=true (redirects to quiz or recommendation based on customerEmail)
 * - discount_code=GETSTARTED
 * - email=address@
 * - go_checkout=true (fetches cart and goes to checkout)
 * - extend-timeout=true (saves extendTimeout in localStorage)
 * - no_timeout=true (saves noTimeout in localStorage; removes from URL)
 * - customerEmail=address@ (stores in localStorage customerEmail; skipped on pages/recommendation and pages/your-protocol)
 */


(function() {
  'use strict';
  
  // Configuration
  //const WELCOME_DISCOUNT_CODE = 'GETSTARTED';
  const WELCOME_DISCOUNT_CODE = 'SUBSCRIBE_AND_SAVE';
  const CART_API = 'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/SHOPIFY_getCartMetafield/';
  const QUIZ_API = 'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/SHOPIFY_getQuizAnalysis/';

  // Selling Plan IDs
  const SELLING_PLAN_ID_SUPPLEMENT = "6827213091"; // TODO: Add supplement selling plan ID
  const SELLING_PLAN_ID_BOX_APP = null; // TODO: Add box/app selling plan ID
  
  // Function to get and remove discount_code parameter from URL
  function getAndRemoveDiscountCodeFromURL() {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get('discount_code');

    if (raw == null) return null;

    // Remove the discount_code parameter from URL
    url.searchParams.delete('discount_code');
    window.history.replaceState({}, '', url.toString());

    const code = raw.trim();
    if (!code) return null;

    const upper = code.toUpperCase();
    if (upper === 'GETSTARTED' || upper === 'WELCOME') {
      return 'SUBSCRIBE_AND_SAVE';
    }

    return code;
  }

  // Function to check and store open_discount parameter
  function handleOpenDiscountParameter() {
    const url = new URL(window.location.href);
    const openDiscount = url.searchParams.get('open_discount');
    
    if (openDiscount === 'true') {
      // Store in localStorage
      try {
        localStorage.setItem('open_discount', 'true');
      } catch (error) {
        console.error('❌ Error storing open_discount in localStorage:', error);
      }
      
      // Remove the open_discount parameter from URL
      url.searchParams.delete('open_discount');
      
      // Update the URL without the parameter (without page reload)
      window.history.replaceState({}, '', url.toString());
      
     
    }
  }
  
  // Function to check and handle continue parameter
  function handleContinueParameter() {
    const url = new URL(window.location.href);
    const continueParam = url.searchParams.get('continue');
    
    if (continueParam === 'true') {
      
      
      // Store shouldATC flag in localStorage
      try {
        localStorage.setItem('shouldATC', 'true');
        
      } catch (error) {
        console.error('❌ Error storing shouldATC in localStorage:', error);
      }
      
      // Remove continue from URL params
      url.searchParams.delete('continue');
      
      // Update URL without continue param
      window.history.replaceState({}, '', url.toString());
      
     
      return true;
    }
    
    return false;
  }

  // Function to handle scroll parameter
  function handleScrollParameter() {
    const url = new URL(window.location.href);
    const scrollParam = url.searchParams.get('scroll');
    
    if (scrollParam) {
      
      // Remove scroll from URL params
      url.searchParams.delete('scroll');
      
      // Update URL without scroll param
      window.history.replaceState({}, '', url.toString());
      
      
      
      // Start scrolling to the element
      scrollToElement(scrollParam);
      
      return true;
    }
    
    return false;
  }

  // Function to handle no_timeout parameter
  function handleNoTimeoutParameter() {
    const url = new URL(window.location.href);
    const noTimeout = url.searchParams.get('no_timeout');

    if (noTimeout === 'true') {
      try {
        localStorage.setItem('noTimeout', 'true');
      } catch (error) {
        console.error('❌ Error storing noTimeout in localStorage:', error);
      }

      url.searchParams.delete('no_timeout');
      window.history.replaceState({}, '', url.toString());
      return true;
    }

    return false;
  }

  // Function to handle extend-timeout parameter
  function handleExtendTimeoutParameter() {
    const url = new URL(window.location.href);
    const extendTimeout = url.searchParams.get('extend-timeout');
    
    if (extendTimeout === 'true') {
      try {
        localStorage.setItem('extendTimeout', 'true');
      } catch (error) {
        console.error('❌ Error storing extendTimeout in localStorage:', error);
      }
      
      url.searchParams.delete('extend-timeout');
      window.history.replaceState({}, '', url.toString());
      return true;
    }
    
    return false;
  }

  // Dispatch event when customerEmail is updated in localStorage (so other scripts can react).
  function dispatchCustomerEmailUpdated() {
    try {
      console.log('dispatching customerEmailUpdated')
      window.dispatchEvent(new CustomEvent('customerEmailUpdated'));
    } catch (e) {}
  }

  // Get email from URL only (does not remove params). Used to trigger cart/quiz fetch before params are stripped.
  function getEmailFromURL() {
    const url = new URL(window.location.href);
    const email = url.searchParams.get('customerEmail') || url.searchParams.get('email');
    return email && typeof email === 'string' ? email.trim() : null;
  }

  // Fetch cart for a given email (same API as your-protocol-loading-section). Returns cart object or null.
  function fetchCartForEmail(email) {
    if (!email) return Promise.resolve(null);
    const apiUrl = CART_API + encodeURIComponent(email);
    return fetch(apiUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP error! status: ' + response.status);
        return response.text();
      })
      .then(function (lastCartString) {
        const data = JSON.parse(lastCartString);
        const cart = data && data.cart != null ? data.cart : null;
        if (cart && typeof cart === 'object' && !Array.isArray(cart)) {
          return cart;
        }
        return null;
      })
      .catch(function (err) {
        console.warn('[auto-welcome-discount] Cart fetch failed:', err);
        return null;
      });
  }

  // Fetch quiz data for a given email (same logic as your-protocol-loading-section). Saves to window + localStorage; on success saves email to customerEmail. Returns true on success, false otherwise.
  function fetchQuizDataForEmail(email) {
    if (!email) return Promise.resolve(false);
    return new Promise(function (resolve) {
      try {
        const urlPersonalApi = QUIZ_API + encodeURIComponent(email);
        fetch(urlPersonalApi, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP error! status: ' + response.status);
            return response.json();
          })
          .then(function (json) {
            const quizAnswers = (json.metafields || []).filter(function (mf) { return mf.namespace === 'quiz_analysis'; });
            if (!quizAnswers || quizAnswers.length === 0) throw new Error('No quiz answers found');
            const lastQuiz = quizAnswers[quizAnswers.length - 1];
            const quiz = JSON.parse(lastQuiz.value);
            const personalInfo = quiz.personalInfo;
            if (!personalInfo) throw new Error('No personal info found');
            const rec = personalInfo['recommendation'];
            const food = personalInfo['foodContent2'];
            const sorted = personalInfo['sortedNeeds'];
            const fbGender = personalInfo.gender === 'Male' ? 'm' : 'f';
            if (rec) {
              localStorage.setItem('recommendation', JSON.stringify(rec));
              window.currentRecommendations = rec;
            }
            if (food) {
              localStorage.setItem('foodContent', JSON.stringify(food));
              window.foodContent = food;
            }
            if (sorted) {
              localStorage.setItem('sortedNeeds', JSON.stringify(sorted));
              window.sortedNeeds = sorted;
            }
            if (fbGender) {
              localStorage.setItem('gender', fbGender);
              window.gender = fbGender;
            }
            // Only set customerEmail after all of the above completed with no error
            localStorage.setItem('customerEmail', email);
            dispatchCustomerEmailUpdated();
            resolve(true);
          })
          .catch(function (err) {
            console.warn('[auto-welcome-discount] Quiz data fetch failed:', err);
            resolve(false);
          });
      } catch (e) {
        console.warn('[auto-welcome-discount] fetchQuizDataForEmail error:', e);
        resolve(false);
      }
    });
  }

  // Function to handle customerEmail parameter (stores in localStorage; skipped on recommendation and your-protocol)
  function handleCustomerEmailParameter() {
    const url = new URL(window.location.href);
    const pathname = url.pathname || '';
    if (pathname.includes('/pages/recommendation') || pathname.includes('/pages/your-protocol')) {
      return false;
    }
    const customerEmail = url.searchParams.get('customerEmail');
    if (customerEmail) {
      try {
        localStorage.setItem('customerEmail', customerEmail.trim());
        dispatchCustomerEmailUpdated();
      } catch (error) {
        console.error('❌ Error storing customerEmail in localStorage:', error);
      }
      url.searchParams.delete('customerEmail');
      window.history.replaceState({}, '', url.toString());
      return true;
    }
    return false;
  }

  // Function to handle email parameter
  function handleEmailParameter() {
    const url = new URL(window.location.href);
    const pathname = url.pathname || '';
    if (pathname.includes('/pages/your-protocol')) {
      return false;
    }
    const email = url.searchParams.get('email');
    if (email) {
     
      
      // Store email in localStorage
      try {
        localStorage.setItem('emailMailchimp', email.trim());
        
      } catch (error) {
        console.error('❌ Error storing email in localStorage:', error);
      }
      
      // Remove email from URL params
      url.searchParams.delete('email');
      
      // Update URL without email param
      window.history.replaceState({}, '', url.toString());
      
      
      return true;
    }
    
    return false;
  }

  // Function to handle take-the-quiz parameter
  function handleTakeTheQuizParameter() {
    const url = new URL(window.location.href);
    const takeTheQuiz = url.searchParams.get('take-the-quiz');
    
    if (takeTheQuiz === 'true') {
     
      
      // Remove take-the-quiz from URL params
      url.searchParams.delete('take-the-quiz');
      
      // Update URL without take-the-quiz param
      window.history.replaceState({}, '', url.toString());
      
     
      
      // Check for customerEmail in localStorage
      const customerEmail = localStorage.getItem('customerEmail');
      
      if (customerEmail) {

        //window.location.href = 'https://www.nutricode.io/pages/recommendation';
      } else {
       
        //window.location.href = 'https://www.nutricode.io/#quiz-4pHJwYp';
      }

      openQuizPopupCustom();
      
      return true;
    }
    
    return false;
  }

  // Function to get email from URL or localStorage
  function getEmailFromURLOrStorage() {
    const url = new URL(window.location.href);
    
    // First check URL parameters (don't remove them)
    const urlEmail = url.searchParams.get('email') || url.searchParams.get('customerEmail');
    if (urlEmail) {
      return urlEmail.trim();
    }
    
    // Then check localStorage
    const customerEmail = localStorage.getItem('customerEmail');
    if (customerEmail) {
      return customerEmail.trim();
    }
    
    const emailMailchimp = localStorage.getItem('emailMailchimp');
    if (emailMailchimp) {
      return emailMailchimp.trim();
    }
    
    return null;
  }

  // Function to clear the current cart
  async function clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Failed to clear cart: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('❌ Error clearing cart:', error);
      throw error;
    }
  }

  // Function to add item to cart by variant ID with optional selling plan (with retry logic)
  async function addItemToCart(variantId, quantity = 1, sellingPlanId = null, maxRetries = 5, retryDelay = 200) {
    // Ensure variant ID is a number (Shopify expects numeric IDs)
    const numericVariantId = typeof variantId === 'string' ? parseInt(variantId, 10) : variantId;
    
    if (isNaN(numericVariantId)) {
      throw new Error(`Invalid variant ID: ${variantId}`);
    }
    
    // Use FormData instead of JSON (matching global-function.js pattern)
    const formData = new FormData();
    formData.append("id", numericVariantId);
    formData.append("quantity", quantity);
    
    // Add selling plan if provided (keep as string)
    if (sellingPlanId) {
      formData.append("selling_plan", sellingPlanId);
    }
    
    let lastError = null;
    
    // Retry logic: up to 5 times with 200ms delay
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (!response.ok) {
          // Try to get error details from response
          let errorMessage = `Failed to add item to cart: ${response.status}`;
          try {
            const errorData = await response.json();
            if (errorData.description || errorData.message) {
              errorMessage += ` - ${errorData.description || errorData.message}`;
            }
          } catch (e) {
            // If we can't parse the error, just use the status
          }
          
          // If it's the last attempt, throw the error
          if (attempt === maxRetries) {
            console.error(`❌ ${errorMessage} (after ${maxRetries} attempts)`, {
              variantId: numericVariantId,
              sellingPlanId: sellingPlanId
            });
            throw new Error(errorMessage);
          }
          
          // Otherwise, log warning and retry
          console.warn(`⚠️ Failed to add item to cart (attempt ${attempt}/${maxRetries}), retrying in ${retryDelay}ms...`, {
            variantId: numericVariantId,
            status: response.status
          });
          
          lastError = new Error(errorMessage);
          await new Promise(resolve => setTimeout(resolve, retryDelay));
          continue;
        }
        
        // Success - return the result
        return await response.json();
      } catch (error) {
        // If it's the last attempt, throw the error
        if (attempt === maxRetries) {
          console.error(`❌ Error adding variant ${variantId} to cart (after ${maxRetries} attempts):`, error);
          throw error;
        }
        
        // Otherwise, log warning and retry
        console.warn(`⚠️ Error adding item to cart (attempt ${attempt}/${maxRetries}), retrying in ${retryDelay}ms...`, error.message);
        lastError = error;
        await new Promise(resolve => setTimeout(resolve, retryDelay));
      }
    }
    
    // This should never be reached, but just in case
    throw lastError || new Error(`Failed to add item to cart after ${maxRetries} attempts`);
  }

  // Function to add multiple items to cart with retry logic and batching
  async function addItemsToCartParallel(items) {
    try {
      // Process items in smaller batches to avoid overwhelming the server
      const batchSize = 3; // Process 3 items at a time
      const results = [];
      
      for (let i = 0; i < items.length; i += batchSize) {
        const batch = items.slice(i, i + batchSize);
        
        // Create add requests for this batch
        const batchPromises = batch.map(async (item) => {
          try {
            // Try adding with selling plan first
            return await addItemToCart(item.variantId, item.quantity || 1, item.sellingPlanId || null);
          } catch (error) {
            // If it fails with 409 (Conflict), try without selling plan
            if (error.message && error.message.includes('409') && item.sellingPlanId) {
              console.warn(`⚠️ Retrying variant ${item.variantId} without selling plan after 409 error`);
              try {
                return await addItemToCart(item.variantId, item.quantity || 1, null);
              } catch (retryError) {
                console.error(`❌ Failed to add variant ${item.variantId} even without selling plan:`, retryError);
                throw retryError;
              }
            }
            throw error;
          }
        });
        
        // Wait for this batch to complete
        const batchResults = await Promise.allSettled(batchPromises);
        results.push(...batchResults);
        
        // Small delay between batches to avoid overwhelming the server
        if (i + batchSize < items.length) {
          await new Promise(resolve => setTimeout(resolve, 100)); // 100ms delay between batches
        }
      }
      
      // Check for any failures
      const failures = results.filter(result => result.status === 'rejected');
      if (failures.length > 0) {
        console.warn(`⚠️ ${failures.length} items failed to add to cart`);
        failures.forEach(failure => console.error('Failed item:', failure.reason));
      }
      
      return results;
    } catch (error) {
      console.error('❌ Error adding items to cart in parallel:', error);
      throw error;
    }
  }
  
  // Fast checkout function that parallelizes operations
  async function shortcutCheckout() {
    try {
      // Get currentSupplementCart from window or localStorage
      let supplementCart = window.currentSupplementCart;
      
      console.log('supplementCart', supplementCart);
      console.log('localStorage.getItem("currentSupplementCart")', localStorage.getItem('currentSupplementCart'));
      console.log('window.currentSupplementCart', window.currentSupplementCart);
      if (!supplementCart) {
        const storedCart = localStorage.getItem('currentSupplementCart');
        if (storedCart) {
          supplementCart = JSON.parse(storedCart);
        }
      }
      
      // Check if supplementCart is an object/dictionary (not an array)
      if (!supplementCart || (typeof supplementCart !== 'object') || Array.isArray(supplementCart)) {
        console.error('❌ currentSupplementCart is not available or invalid. Expected an object/dictionary.');
        return false;
      }
      
      // Step 1: Clear the current cart
      await clearCart();
      
      // Step 2: Prepare supplement items from currentSupplementCart
      // supplementCart is an object where keys are supplement names and values are arrays
      // Each array should have variant ID at index 4
      const supplementItems = [];
      
      // Iterate over the object entries
      for (const [supplementName, supplementArray] of Object.entries(supplementCart)) {
        // Check if the value is an array and has at least 5 elements (indices 0-4)
        if (Array.isArray(supplementArray) && supplementArray.length > 4 && supplementArray[4]) {
          const variantId = parseInt(supplementArray[4], 10);
          if (!isNaN(variantId)) {
            supplementItems.push({
              variantId: variantId, // Variant ID at index 4, parsed as integer
              quantity: 1,
              sellingPlanId: SELLING_PLAN_ID_SUPPLEMENT // Use hardcoded supplement selling plan
            });
            console.log(`📦 Prepared supplement: ${supplementName}, variantId: ${variantId}, sellingPlan: ${SELLING_PLAN_ID_SUPPLEMENT}`);
          } else {
            console.warn(`⚠️ Supplement "${supplementName}" has invalid variant ID at index 4: ${supplementArray[4]}`);
          }
        } else {
          console.warn(`⚠️ Supplement "${supplementName}" does not have a valid variant ID at index 4. Array length: ${Array.isArray(supplementArray) ? supplementArray.length : 'not an array'}`);
        }
      }
      
      console.log(`📦 Total supplements to add: ${supplementItems.length}`);
      
      // Step 3: Prepare box and app items with hardcoded variant IDs
      const variantIdBox = parseInt("53559051747619", 10);
      const variantIdApp = parseInt("53559300587811", 10);
      

      
      const boxAndAppItems = [
        {
          variantId: variantIdBox,
          quantity: 1,
          sellingPlanId: SELLING_PLAN_ID_BOX_APP // Use hardcoded box/app selling plan
        },
        {
          variantId: variantIdApp,
          quantity: 1,
          sellingPlanId: SELLING_PLAN_ID_BOX_APP // Use hardcoded box/app selling plan
        }
      ];
      
      // Step 5: Add all items in parallel (supplements + box + app)
      const allItems = [...supplementItems, ...boxAndAppItems];
      
      if (allItems.length === 0) {
        console.error('❌ No items to add to cart');
        return false;
      }
      
      // Add all items in parallel for maximum speed
      await addItemsToCartParallel(allItems);
      
      // Step 6: Get discount codes from URL parameters or localStorage
      const url = new URL(window.location.href);
      let discountCodes = [];
      
      // Check URL parameters first
      const urlDiscount = url.searchParams.get('discount_code');
      if (urlDiscount) {
        // Split by comma if multiple discounts
        discountCodes = urlDiscount.split(',').map(code => code.trim()).filter(code => code);
      }
      
      // If no URL discount, check localStorage
      if (discountCodes.length === 0) {
        const storedDiscounts = localStorage.getItem('appliedDiscounts');
        if (storedDiscounts) {
          try {
            const parsedDiscounts = JSON.parse(storedDiscounts);
            if (typeof parsedDiscounts === 'object' && parsedDiscounts !== null) {
              discountCodes = Object.keys(parsedDiscounts).filter(code => code);
            }
          } catch (error) {
            console.warn('⚠️ Could not parse appliedDiscounts from localStorage:', error);
          }
        }
      }
      
      // If still no discounts, use WELCOME as default
      if (discountCodes.length === 0) {
        discountCodes = [WELCOME_DISCOUNT_CODE];
      }
      
      // Step 7: Hide loading overlay before redirect
      if (typeof window.hideLoadingCartPopup === 'function') {
        window.hideLoadingCartPopup();
      }
      
      // Step 8: Go to checkout with discount codes in URL
      if (discountCodes.length > 0) {
        const discountQuery = discountCodes.map(code => encodeURIComponent(code)).join(',');
        window.location.href = `/checkout?discount=${discountQuery}`;
      } else {
        window.location.href = '/checkout';
      }
      
      return true;
    } catch (error) {
      console.error('❌ Error in shortcutCheckout:', error);
      // Hide loading overlay on error
      if (typeof window.hideLoadingCartPopup === 'function') {
        window.hideLoadingCartPopup();
      }
      return false;
    }
  }

  // Function to handle go_checkout parameter
  async function handleGoCheckoutParameter() {
    const url = new URL(window.location.href);
    const goCheckout = url.searchParams.get('go_checkout');
    
    if (goCheckout === 'true') {
      
      // Remove go_checkout from URL params
      url.searchParams.delete('go_checkout');
      
      // Update URL without go_checkout param
      window.history.replaceState({}, '', url.toString());
      
      // Show loading overlay
      if (typeof window.showLoadingCartPopup === 'function') {
        window.showLoadingCartPopup();
      }
      
      // Get email from URL or localStorage
      const email = getEmailFromURLOrStorage();
      
      if (!email) {
        console.error('❌ No email found for go_checkout. Need email in URL (email/customerEmail) or localStorage (customerEmail/emailMailchimp)');
        // Hide loading overlay on error
        if (typeof window.hideLoadingCartPopup === 'function') {
          window.hideLoadingCartPopup();
        }
        return false;
      }
      
      try {
        // Fetch cart metafield from API
        const apiUrl = `https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/SHOPIFY_getCartMetafield/${encodeURIComponent(email)}`;
        
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // Get the stringified JSON response
        const lastCartString = await response.text();
        
        console.log('lastCartString', JSON.parse(lastCartString).cart);
        // Parse the JSON and set it to window.currentSupplementCart
        window.currentSupplementCart = JSON.parse(lastCartString).cart;
        localStorage.setItem("currentSupplementCart", JSON.stringify(JSON.parse(lastCartString).cart));
        
        // Call shortcutCheckout instead of globalGoToCheckout
        // Note: shortcutCheckout will hide the overlay before redirecting
        await shortcutCheckout();
        
        return true;
      } catch (error) {
        console.error('❌ Error in go_checkout logic:', error);
        // Hide loading overlay on error
        if (typeof window.hideLoadingCartPopup === 'function') {
          window.hideLoadingCartPopup();
        }
        return false;
      }
    }
    
    return false;
  }

  // Function to scroll to an element by ID
  function scrollToElement(elementId) {
   
    
    let attempts = 0;
    const maxAttempts = 100; // Try for 10 seconds (100 * 100ms)
    const intervalTime = 100;
    
    const scrollInterval = setInterval(() => {
      attempts++;
      
      const element = document.getElementById(elementId);
      
      if (element) {
        
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
        clearInterval(scrollInterval);
        return;
      }
      
      if (attempts >= maxAttempts) {
        
        clearInterval(scrollInterval);
        return;
      }
      
      
    }, intervalTime);
  }
  
  // Function to remove WELCOME discount if it exists
  function removeWelcomeDiscount() {
    try {
      const appliedDiscounts = getAppliedDiscounts();
      
      if (appliedDiscounts[WELCOME_DISCOUNT_CODE]) {
        delete appliedDiscounts[WELCOME_DISCOUNT_CODE];
        saveAppliedDiscounts(appliedDiscounts);

      }
    } catch (error) {
      console.error('❌ Error removing WELCOME discount:', error);
    }
  }
  
  // Function to apply a discount code
  async function applyDiscountCode(discountCode) {
    try {
     
      const result = await globalAddDiscount(
        discountCode, 
        null, 
        "Checking...", 
        "Applied", 
        "Invalid", 
        "Applied"
      );
      
      if (result.success) {
       
        return true;
      } else {
        
        return false;
      }
    } catch (error) {
      console.error(`❌ Error applying discount code ${discountCode}:`, error);
      return false;
    }
  }
  
  // Function to apply WELCOME discount as fallback
  async function applyWelcomeDiscount() {
    try {
      
      
      const result = await globalAddDiscount(
        WELCOME_DISCOUNT_CODE, 
        null, 
        "Checking...", 
        "Applied", 
        "Invalid", 
        "Applied"
      );
      
      if (result.success) {
       
      } else {
       
      }
    } catch (error) {
      console.error('❌ Error applying WELCOME discount:', error);
    }
  }
  
  // Function to handle ATC (Add to Cart) logic based on current page
  async function handleATCLogic() {
    try {
      const shouldATC = localStorage.getItem('shouldATC');
      
      if (shouldATC !== 'true') {
        
        return;
      }
      

      
      // Add 4-second delay before adding anything to cart
     
      await new Promise(resolve => setTimeout(resolve, 4000));
     
      
      const currentUrl = window.location.href;
      const urlPath = new URL(currentUrl).pathname;
      
      // Define URL mappings
      const boxUrls = {
        "Your Protocol": "/pages/recommendation",
        "The Energy Protocol": "/products/energy-protocol",
        "The Sleep Protocol": "/products/sleep-protocol",
        "The Fitness Protocol": "/products/fitness-protocol"
      };
      
      const supplementUrls = {
        "Ashwagandha": "/products/ashwagandha",
        "Biotin": "/products/biotin",
        "Calcium": "/products/calcium",
        "CoQ10": "/products/coq10",
        "Folic Acid": "/products/folic-acid",
        "Iron": "/products/iron",
        "Magnesium": "/products/magnesium",
        "Omega 3": "/products/omega-3",
        "Probiotics": "/products/probiotics",
        "Vitamin B12": "/products/vitamin-b12",
        "Vitamin B2": "/products/vitamin-b2",
        "Vitamin B6": "/products/vitamin-b6",
        "Vitamin C": "/products/vitamin-c",
        "Vitamin D": "/products/vitamin-d3",
        "Vitamin E": "/products/vitamin-e",
        "Zinc": "/products/zinc"
      };
      
      // Check if we're on a result page (recommendation)
      if (urlPath.includes('pages/recommendation')) {

        await globalAddBoxToCart(
          "Your Protocol",
          null,
          "Adding...",
          "Added",
          "addToCartFromResultPage",
          true
        );
      }
      // Check if we're on a box page
      else if (urlPath.includes('energy-protocol')) {
       
        await globalAddBoxToCart(
          "Energy",
          null,
          "Adding...",
          "Added",
          "addToCartFromResultPage",
          true
        );
      }
      else if (urlPath.includes('sleep-protocol')) {
      
        await globalAddBoxToCart(
          "Sleep",
          null,
          "Adding...",
          "Added",
          "addToCartFromResultPage",
          true
        );
      }
      else if (urlPath.includes('fitness-protocol')) {
       
        await globalAddBoxToCart(
          "Fitness",
          null,
          "Adding...",
          "Added",
          "addToCartFromResultPage",
          true
        );
      }
      // Check if we're on a supplement page
      else {
        let supplementFound = false;
        
        for (const [supplementName, supplementPath] of Object.entries(supplementUrls)) {
          if (urlPath.includes(supplementPath.replace('/products/', ''))) {
           
            await globalAddSupplementToCart(
              supplementName,
              null,
              "Adding...",
              "Added to Stack",
              "addToCartFromDrawer",
              true
            );
            supplementFound = true;
            break;
          }
        }
        
        if (!supplementFound) {
         
        }
      }
      
      // Clear the shouldATC flag from localStorage
      localStorage.removeItem('shouldATC');
     
      
    } catch (error) {
      console.error('❌ Error in ATC logic:', error);
      
      // Clear the shouldATC flag even on error
      localStorage.removeItem('shouldATC');
    }
  }
  
  // Main function to handle discount logic
  async function handleDiscountLogic() {
    try {
      // If there is an email in the URL, fetch cart and quiz data in parallel (before stripping params).
      // Cart is applied whenever the cart fetch succeeds, even if the quiz fetch fails.
      const emailFromUrl = getEmailFromURL();
      if (emailFromUrl) {
        const results = await Promise.allSettled([
          fetchCartForEmail(emailFromUrl),
          fetchQuizDataForEmail(emailFromUrl)
        ]);
        const cartResult = results[0];
        if (cartResult.status === 'fulfilled' && cartResult.value && typeof cartResult.value === 'object' && !Array.isArray(cartResult.value)) {
          const fetchedCart = cartResult.value;
          window.currentSupplementCart = fetchedCart;
          try {
            localStorage.setItem('currentSupplementCart', JSON.stringify(fetchedCart));
          } catch (e) {}
        }
      }

      // Handle email parameter first
      handleEmailParameter();
      // Handle customerEmail parameter (not on recommendation/your-protocol)
      handleCustomerEmailParameter();
      
      // Handle go_checkout parameter (before other logic, as it may redirect)
      const hasGoCheckout = await handleGoCheckoutParameter();
      if (hasGoCheckout) {
       
        return; // Stop execution if checkout redirect happens
      }
      
      // Handle take-the-quiz parameter (before other logic)
      const hasTakeTheQuiz = handleTakeTheQuizParameter();
      if (hasTakeTheQuiz) {
       
        return; // Stop execution if redirect happens
      }
      
      // Handle open_discount parameter
      handleOpenDiscountParameter();
      
      // Handle extend-timeout parameter
      handleExtendTimeoutParameter();

      // Handle no_timeout parameter
      handleNoTimeoutParameter();

      // Handle continue parameter
      handleContinueParameter();
      
      // Handle scroll parameter
      handleScrollParameter();
      
      // Get discount code from URL first
      const urlDiscountCode = getAndRemoveDiscountCodeFromURL();
      
      let discountSuccess = false;
      
      if (urlDiscountCode) {
        // Remove WELCOME discount if it exists
        //removeWelcomeDiscount();
        
        // Try to apply the URL discount code
        const success = await applyDiscountCode(urlDiscountCode);
        
        if (!success) {
          // If URL discount failed, apply WELCOME as fallback
          //await applyWelcomeDiscount();
        }
        discountSuccess = true;
      } else {
        // No URL discount code, check if discounts are already applied
        const appliedDiscounts = getAppliedDiscounts();
        const hasExistingDiscounts = Object.keys(appliedDiscounts).length > 0;
        
        if (hasExistingDiscounts) {
          
          discountSuccess = true; // Consider this successful since discounts are already applied
        } else {
          // No existing discounts, apply WELCOME discount
          //await applyWelcomeDiscount();
          discountSuccess = true;
        }
      }
      
      // Only handle ATC logic after discount processing is fully completed
      if (discountSuccess) {
        
        await handleATCLogic();
      }
      
    } catch (error) {
      console.error('❌ Error in discount logic:', error);
      
      // Fallback to WELCOME discount on any error
      try {
        //await applyWelcomeDiscount();
       
        await handleATCLogic();
      } catch (fallbackError) {
        console.error('❌ Error applying WELCOME fallback:', fallbackError);
        
        
        // Still proceed with ATC logic even if both discounts failed
        // The user came with continue=true parameter, so we should honor that
        await handleATCLogic();
      }
    }
  }
  
  // Initialize when DOM is ready
  function initializeWelcomeDiscount() {
    // Wait for global functions to be available
    const checkInterval = setInterval(() => {
      if (typeof globalAddDiscount !== 'undefined' && 
          typeof getAppliedDiscounts !== 'undefined' && 
          typeof saveAppliedDiscounts !== 'undefined') {
        clearInterval(checkInterval);
        
        // Handle discount logic
        handleDiscountLogic();
      }
    }, 100);
    
    // Clear interval after 10 seconds to prevent infinite checking
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 10000);
  }
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWelcomeDiscount);
  } else {
    initializeWelcomeDiscount();
  }
  
})();
